import { render } from "./periodicidadeFilter.vue?vue&type=template&id=f18fc4f8&scoped=true"
import script from "./periodicidadeFilter.vue?vue&type=script&lang=js"
export * from "./periodicidadeFilter.vue?vue&type=script&lang=js"

import "./periodicidadeFilter.vue?vue&type=style&index=0&id=f18fc4f8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f18fc4f8"]])

export default __exports__